import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=308fcf60&"
import script from "./fullscreen.vue?vue&type=script&lang=js&"
export * from "./fullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports